<template>
  <div class="no_result">
    <p>검색된 마이팩이 없습니다.</p>
    <p>입력하신 내용을 확인 후 다시 검색해 보세요.</p>
  </div>
</template>

<script>
export default {
  name: 'MypackNoSearch',

};
</script>



// WEBPACK FOOTER //
// src/views/mypacks/main/partial/MypackNoSearch.vue